<template>
  <div class="home">
    <div class="inpPlate">
      <div class="inp">
        <div class="plate">
          <span>车牌</span>
          <el-input
            placeholder="请输入需要优惠的车牌"
            v-model="plate"
            clearable
          >
          </el-input>
          <el-button type="primary" @click="find" icon="el-icon-search"
            >查询</el-button
          >
          <span style="color: red; width: 5rem; font-size: 0.2rem"></span>
        </div>
      </div>
      <el-table :data="tableData" border>
        <el-table-column
          fixed
          prop="parkId"
          label="车场编号"
          v-loading="loading"
        >
        </el-table-column>
        <el-table-column prop="plate" label="车牌号"> </el-table-column>
        <el-table-column prop="inTime" label="入场时间"> </el-table-column>
        <el-table-column prop="stopTimeStr" label="停车时长"> </el-table-column>
        <el-table-column prop="actualCharge" label="收费金额">
        </el-table-column>
        <el-table-column prop="discountVal" label="已优惠"> </el-table-column>
        <el-table-column fixed="right" label="入场图片">
          <template>
            <div class="demo-image__preview">
              <el-image
                style="width: 200px; height: 60px"
                :src="url"
                :preview-src-list="srcList"
              >
              </el-image>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="discounts">
        <div
          class="ticket"
          v-for="(item, index) in shopCouponList"
          :key="item.id"
        >
          <div
            class="coupon coupon-wave-left coupon-wave-right coupon-yellow-gradient"
          >
            <div class="coupon-info coupon-info-right-dashed">
              <div class="coupon-store">{{ shopName }}</div>
              <div class="coupon-price">{{ item.name }}</div>
            </div>
            <div class="coupon-get">
              <div class="coupon-desc">{{ item.remark }}张</div>
            </div>
          </div>
          <div class="enter">
            <input type="button" value="-" @click="subtraction(index)" />
            <span>{{ item.remark }}</span>
            <input type="button" value="+" @click="addition(index)" />
          </div>
        </div>
        <div class="mark">
          <span>备注</span>
          <el-input
            type="text"
            placeholder="优惠券备注"
            v-model="remark"
          ></el-input>
        </div>
      </div>

      <div class="statistics">
        <p>
          {{ticketTotal}}：<span class="sale">{{ limit }}{{ ticketName }}</span>
        </p>
        <p>
          {{ticketTotal == "优惠合计"?"扣费金额":"最大扣费金额"}}：<span class="debit">{{ticketTotal == "优惠合计"?money:limit}}元</span>
        </p>
        <p>
          <el-button type="primary" @click="affirm" :disabled="submits"
            >确认优惠</el-button
          >
        </p>
        <p><el-button type="primary" @click="dynamic">无牌车优惠</el-button></p>
      </div>

      <div class="reminder">
        <p>
          <span>提示：</span
          >无牌车优惠时，请先选择优惠券，后点击无牌车优惠按钮，待优惠二维码生成时请车主扫码进行优惠。
        </p>
      </div>
    </div>

    <div class="qrs" v-show="show">
      <span class="del" @click="del">X</span>
      <div class="poster-container" ref="imageTofile">
        <div class="poster-bg-img newbg">
          <div class="poster-bg-mask"></div>
        </div>
        <div class="poster-content">
          <div id="qrcode" ref="qrcode"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { util } from "../utils/global";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      plate: "", // 车牌检索框
      parkId: "",
      tableData: [],
      shopCouponList: [], // 优惠券列表
      // 停车场id
      // parkId: 0,
      // 使用的优惠卷ID
      shopCouponId: "",
      // 接收券的单位
      unit: 0,
      // 判断券的单位是否一致
      units: 0,
      // 账户余额
      balance: 0,
      // 页面中展示叠加或卷面值
      limit: 0,
      // 卷扣费金额
      money: 0,
      // 优惠描述
      ticketTotal:"优惠合计",
      // 优惠卷的使用数量
      amount: 0,
      // 判断当前商户卷是否能够进行叠加
      addconuts: 0,
      // 判断是否已经使用
      employ: 0,
      // 判断当前券的类型
      type: 0,
      // 可叠加时判断类型
      verdict: {},
      // 扣费金额
      free: "扣费（元）",
      // 券统计单位
      ticketName: "",
      // 表格加载动画
      loading: false,
      // 车辆入场图
      url: "",
      // 车辆入场大图
      srcList: [],
      // 车辆优惠备注
      remark: "",
      // 商家名称
      shopName: "",
      // 固定码参数
      placeholder: "",
      show: false,
      time: "",
      imgsrc: "",
      submits: false,
    };
  },

  mounted() {
    this.balance = this.$store.state.balance;
    let data = JSON.parse(sessionStorage.getItem("shopData"));
    for (var i = 0; i < data.shopCouponList.length; i++) {
      data.shopCouponList[i]["num"] = 0;
    }
    this.parkId = data.shopUser.parkId;
    this.addconuts = data.shop.addCount;
    this.shopCouponList = data.shopCouponList;
    this.shopName = data.shop.name;
  },
  methods: {
    // 车辆优惠
    affirm() {
      const that = this;
      that.submits = true;
      let list = JSON.parse(sessionStorage.getItem("shopData"));
      let judge = util.count(that.shopCouponList, "can");
      if (that.tableData[0] == undefined) {
        util.hint(400, "请输入要优惠的车牌号码");
        that.submits = false;
        return;
      }
      if (judge == 0) {
        util.hint(400, "请选择一张优惠券");
        that.submits = false;
        return;
      }
      if (that.money <= that.balance) {
        // 请求生成二维码参数
        let data = {
          parkId: list.shop.parkId,
          shopId: list.shopUser.shopId,
          type: that.type,
          unit: that.unit,
          value: that.unit == 999 ? "0" : that.limit,
          price: that.money,
          userId: list.shopUser.id,
          userName: list.shopUser.realname,
          remark: that.remark,
          recordId: that.tableData[0].id,
        };
        that.$axios.post("confirmOrder", data).then((res) => {
          // console.log(res)
          if (res.code == 0) {
            util.hint(res.code, "车辆优惠成功！");
            that.$store.dispatch("getMessageList");
          } else if (res.code == 400) {
            util.hint(res.code, res.msg);
          } else {
            util.hint("余额不足，请及时充值！", "none", 1500);
            return;
          }
          setTimeout(function () {
            that.$router.go(0);
          }, 2000);
        });
      } else {
        util.hint(400, "余额不足，请及时充值！");
        return;
      }
    },
    // 车辆查询
    find() {
      this.loading = true;
      let list = JSON.parse(sessionStorage.getItem("shopData"));
      this.tableData = [];
      let data = {
        parkId: this.parkId,
        shopId: list.shopUser.shopId,
        plate: this.plate,
      };
      this.$axios
        .post("getCarIn", data)
        .then((res) => {
          if (res.code == 0) {
            var data = res.data;
            this.srcList = [];
            this.srcList.push(data.inPic);
            this.url =
              "http://boot-park2.oss-cn-qingdao.aliyuncs.com" +
              data.inPic.slice(0, -4) +
              "_plate" +
              data.inPic.slice(-4);
            this.tableData.push(this.infoMsg(data));
            this.loading = false;
          } else {
            util.hint(res.code, res.msg);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    infoMsg(data) {
      switch (data.discountType) {
        case 1:
          data.discountVal = data.discountVal + "分钟";
          break;
        case 2:
          data.discountVal = data.discountVal + "元";
          break;
        case 3:
          data.discountVal = data.discountVal * 10 + "折";
          break;
        default:
          break;
      }
      return data;
    },

    // 无牌车优惠
    dynamic() {
      var that = this;
      let list = JSON.parse(sessionStorage.getItem("shopData"));
      let judge = util.count(that.shopCouponList, "can");
      if (judge == 0) {
        util.hint(400, "请选择一张优惠券");
        return;
      }
      if (that.money <= that.balance) {
        // 请求生成二维码参数
        let data = {
          parkId: list.shop.parkId,
          shopId: list.shopUser.shopId,
          type: that.type,
          unit: that.unit,
          value: that.unit == 999 ? "0" : that.limit,
          price: that.money,
          userId: list.shopUser.id,
          userName: list.shopUser.realname,
          remark: that.remark,
        };
        that.$axios.post("createOrder", data).then((res) => {
          if (res.data.code == 400) {
            util.hint(400, res.data.msg);
            return;
          } else {
            that.placeholder =
              "https://shop.otcp.cn/scanQrCode?orderId=" + res.data.orderId;
            that.qrCode(that.placeholder);
            that.$store.dispatch("getMessageList");
          }
        });
      } else {
        util.hint(400, "余额不足，请及时充值！");
        return;
      }
    },
    // 卷数量的递减
    subtraction(i) {
      var arr = this.shopCouponList[i];
      var index = i;
      let array = this.shopCouponList;
      let type = arr.type;
      var timeEnd = parseInt(array[index].remark);
      timeEnd -= 1;
      if (timeEnd >= 0) {
        // 当使用了全免券进行更换时
        if (type == 4) {
          this.employ = 0;
          this.unit = "";
          this.type = 0;
          this.free = "扣费（元）";
          array[index].remark = timeEnd;
          this.getTotalPrice();
          return;
        } else {
          if (timeEnd > 0) {
            // 判断当前券不为0时进入计算
            array[index].remark = timeEnd;
            this.getTotalPrice(); // 计算合计值及金额
          } else if (timeEnd == 0) {
            // 判断当前券张数为0时
            var del = this.verdict;
            delete del[arr.name]; // 将键值对中内容进行删除
            var nums = Object.keys(this.verdict).length; // 判断键值对对象的长度
            if (nums == 0) {
              // 当键值对为 0 时代表券以全部清空，恢复原始数值得以进行后期选择
              this.employ = 0;
              this.unit = 0;
              this.units = this.units;
              this.type = 0;
              this.ticketTotal = "优惠合计";
            }
            array[index].remark = timeEnd;
            this.getTotalPrice();
          }
        }
      } else {
        util.hint(400, "使用的优惠券张数不能小于0");
      }
    },
    // 卷数量的递增
    addition(i) {
      // 拿到当前行数据
      var arr = this.shopCouponList[i];
      var index = i;
      let array = this.shopCouponList;
      let addNum = util.addcount(array);
      if (this.addconuts != 0 && addNum == this.addconuts) {
        util.hint(400, "最多只能使用" + this.addconuts + "张优惠券");
        return false;
      }
      let type = arr.type; // 拿到当前券的类型
      let units = this.units; // 判断是否为同种类型券
      var timeEnd = parseInt(array[index].remark); // 在页面中展示券的使用数量
      timeEnd += 1;
      let num = util.count(array, "add");
      // 使用全免券
      if (
        (type == 4 && this.employ == 0 && timeEnd == 1 && num == 0) ||
        (type == 3 && this.employ == 0) ||
        (type == 10 && this.employ == 0)
      ) {
        if (type == 4) {
          let statu = JSON.parse(sessionStorage.getItem("shopData")).shop
            .isFree;
          if (statu == 2) {
            this.employ = 2;
            this.unit = 999;
            this.type = type;
            this.free = "限额（元）";
          } else {
            this.employ = 2;
            this.unit = 999;
            this.type = type;
          }
        } else if (type == 3) {
          this.employ = 3;
          this.unit = 5;
          this.type = type;
        } else if (type == 10) {
          this.employ = 1;
          this.unit = 10;
          this.type = type;
        }
        array[index].remark = timeEnd;
        this.getTotalPrice();
      } else if (type != 4 && this.employ != 2 && type != 3 && type != 10) {
        // 当前券不属于全免券且没有使用过全免券时且不为折扣券时
        if (this.unit == 0 || array[index].unit == units && array[index].type == this.type) {
          var tianj = this.verdict;
          tianj[arr.name] = timeEnd;
          this.employ = 1;
          this.unit = array[index].unit;
          this.verdict = tianj;
          this.units = array[index].unit;
          this.type = type;
          if (array[index].type == 12) {
              this.employ= 1;
              this.unit= array[index].unit;
              this.type= type;
              this.ticketTotal= "最大减免金额";
          }
        } else {
          util.hint(400, "不同类型券不可叠加");
          return;
        }
        array[index].remark = timeEnd;
        this.getTotalPrice();
      } else if (type == 4 && timeEnd > 1) {
        // 第二次点击全免券时
        util.hint(400, "全免券不能叠加使用");
      } else if (type == 3 && this.employ != 2) {
        util.hint(400, "折扣券不能叠加使用");
      } else if (type == 10) {
        util.hint(400, "特定收费券不能叠加使用");
      } else {
        util.hint(400, "全免券不能与其他优惠类型券叠加使用");
      }
    },

    getTotalPrice() {
      // 计算使用券的总价
      let array = this.shopCouponList; // 获取购物车列表
      let total = 0;
      let amount = 0;
      for (let i = 0; i < array.length; i++) {
        // 循环列表得到每个数据
        amount += array[i].remark * array[i].value; // 所有合计数量
        total += array[i].remark * array[i].price; // 所有价格加起来
      } // 最后赋值到data中渲染到页面
      this.shopCouponList = array;
      this.totalMoney = total.toFixed(2);
      this.money = total.toFixed(2);
      this.limit = amount;
      this.unit = this.unit;
      var ticketName = "";
      switch (this.unit) {
        case 1:
          ticketName = "小时";
          break;
        case 2:
          ticketName = "分钟";
          break;
        case 3:
          ticketName = "天";
          break;
        case 4:
          ticketName = "元";
          break;
        case 5:
          ticketName = "折";
          break;
        case 999:
          ticketName = "全免券";
          break;
        default:
          break;
      }
      if (this.unit == 999) {
        this.limit = "";
      }
      this.ticketName = ticketName;
    },
    del() {
      // 点击关闭二维码时
      this.$router.go(0);
    },
    qrCode(url) {
      // 点击生成图片
      let qrcode = new QRCode("qrcode", {
        width: 255, //图像宽度
        height: 255, //图像高度
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H, //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
      });
      this.time = util.getDays();
      this.show = true;
      qrcode.clear(); //清除二维码
      qrcode.makeCode(url); //生成另一个新的二维码
      setTimeout(() => {
        this.toImage();
      }, 500);
    },
    toImage() {
      // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
      html2canvas(this.$refs.imageTofile, {
        backgroundColor: null,
      }).then((canvas) => {
        let url = canvas.toDataURL("image/png");
        this.imgsrc = url; // 把生成的base64位图片上传到服务器,生成在线图片地址
      });
    },
  },
  watch: {
    // watch 可以监听 data 数据 也可以监听 全局 vuex数据
    //监听vuex中userNumber的变化
    "$store.state.balance"(val) {
      this.balance = val;
    },
  },
};
</script>

<style lang="less" scoped>
@import url(../assets/css/qrCode.css);
@import url(../assets/css/carserve/car.css);
.qrs {
  padding-top: 2rem !important;
  box-sizing: border-box;
}

.poster-bg-img {
  width: 500px;
  height: 656px;
  background: url("../assets/noPlates.jpg") no-repeat;
  background-size: 100%;
}

#qrcode {
  width: 90px;
  height: 90px;
  position: absolute;
  top: 181px;
  left: 122px;
  background-color: #fff;
}

.poster-qrcode-canvas {
  width: 290px;
  height: 290px;
}
</style>


// WEBPACK FOOTER //
// src/components/carSeve.vue